// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import "../../assets/Loan/EmiDueReport.css"; // Reuse premium EMI Due report CSS

// const DepositInstallmentDueReport = () => {
//   const superAdminId = Number(localStorage.getItem("userId")) || 14;

//   const [records, setRecords] = useState([]);
//   const [company, setCompany] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [filter, setFilter] = useState("today");   // today | tomorrow | upcoming
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   // -----------------------------
//   // API ENDPOINTS
//   // -----------------------------
//   const BASE_URL = "https://narrowitsolution.in/api/installments";
//   const API = {
//     today: `${BASE_URL}/today?branchId=${superAdminId}`,
//     tomorrow: `${BASE_URL}/tomorrow?branchId=${superAdminId}`,
//     upcoming: `${BASE_URL}/upcoming?branchId=${superAdminId}`,
//   };

//   // -----------------------------
//   // Fetch Deposit Installments
//   // -----------------------------
//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const res = await axios.get(API[filter]);
//         setRecords(res.data.data || []);
//         setError(null);
//       } catch (err) {
//         setError("Failed to load deposit installments");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [filter]);

//   // -----------------------------
//   // Fetch Company Info
//   // -----------------------------
//   useEffect(() => {
//     const fetchCompany = async () => {
//       try {
//         const res = await fetch(
//           `https://narrowitsolution.in/api/get-company?superAdminId=${superAdminId}`
//         );
//         const data = await res.json();
//         const info = data.data || data;

//         if (info.logo)
//           info.logoUrl = `https://narrowitsolution.in/${info.logo.replace(/^images\//, "")}`;

//         setCompany(info);
//       } catch (err) {
//         console.error("Company info error", err);
//       }
//     };
//     fetchCompany();
//   }, []);

//   // -----------------------------
//   // Loading / Error
//   // -----------------------------
//   if (loading) return <div className="EmiDueReport-loading">Loading...</div>;
//   if (error) return <div className="EmiDueReport-error">{error}</div>;

//   // -----------------------------
//   // Pagination
//   // -----------------------------
//   const totalPages = Math.ceil(records.length / rowsPerPage);
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   const currentData = records.slice(startIndex, startIndex + rowsPerPage);

//   const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
//   const handleNext = () =>
//     currentPage < totalPages && setCurrentPage(currentPage + 1);

//   // -----------------------------
//   // Total Amount Calculation
//   // -----------------------------
//   const totals = currentData.reduce(
//     (acc, item) => acc + (item.amount || 0),
//     0
//   );

//   // -----------------------------
//   // PDF Export
//   // -----------------------------
//   const downloadPDF = () => {
//     const doc = new jsPDF("p", "mm", "a4");
//     const pageWidth = doc.internal.pageSize.width;

//     doc.text("Deposit Installment Due Report", pageWidth / 2, 14, {
//       align: "center",
//     });

//     autoTable(doc, {
//       startY: 20,
//       head: [
//         [
//           "Sr",
//           "Customer",
//           "Account No",
//           "Installment No",
//           "Amount",
//           "Due Date",
//           "Status",
//         ],
//       ],
//       body: currentData.map((item, i) => [
//         startIndex + i + 1,
//         item.customerName,
//         item.accountNo,
//         item.installmentNo,
//         item.amount,
//         new Date(item.dueDate).toLocaleDateString("en-IN"),
//         item.status,
//       ]),
//       theme: "grid",
//     });

//     doc.save("DepositInstallments.pdf");
//   };

//   // -----------------------------
//   // UI Render
//   // -----------------------------
//   return (
//     <div className="EmiDueReport-wrapper">
//       <h1 className="EmiDueReport-title">📋 Deposit Installments Due</h1>

//       {/* Filters */}
//       <div className="EmiDueReport-filters">
//         {["today", "tomorrow", "upcoming"].map((f) => (
//           <button
//             key={f}
//             className={`filter-btn ${filter === f ? "active" : ""}`}
//             onClick={() => {
//               setFilter(f);
//               setCurrentPage(1);
//             }}
//           >
//             {f.toUpperCase()}
//           </button>
//         ))}
//       </div>

//       {/* Controls */}
//       <div className="EmiDueReport-controls">
//         <label>
//           Show{" "}
//           <select
//             value={rowsPerPage}
//             onChange={(e) => {
//               setRowsPerPage(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10</option>
//             <option value={25}>25</option>
//             <option value={50}>50</option>
//           </select>{" "}
//           rows
//         </label>

//         <button className="filter-btn" onClick={downloadPDF}>
//           📄 Download PDF
//         </button>
//       </div>

//       {/* Table */}
//       <div className="EmiDueReport-table-container">
//         <table className="EmiDueReport-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Customer</th>
//               <th>Account No</th>
//               <th>Installment No</th>
//               <th>Amount</th>
//               <th>Due Date</th>
//               <th>Status</th>
//             </tr>
//           </thead>

//           <tbody>
//             {currentData.length === 0 ? (
//               <tr>
//                 <td colSpan="7" className="EmiDueReport-empty">
//                   No records found
//                 </td>
//               </tr>
//             ) : (
//               currentData.map((item, idx) => (
//                 <tr key={idx}>
//                   <td>{startIndex + idx + 1}</td>
//                   <td>{item.account.customerName}</td>
//                   <td>{item.account.accountNo}</td>
//                   <td>{item.installmentNo}</td>
//                   <td>₹{item.amount}</td>
//                   <td>{new Date(item.dueDate).toLocaleDateString("en-IN")}</td>
//                   <td>
//                     <span
//                       className={`EmiDueReport-status ${
//                         item.status === "Paid" ? "paid" : "pending"
//                       }`}
//                     >
//                       {item.status}
//                     </span>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>

//           {/* Total Row */}
//           <tfoot>
//             <tr className="EmiDueReport-total-row">
//               <td colSpan="4" style={{ textAlign: "right", fontWeight: "bold" }}>
//                 Total:
//               </td>
//               <td style={{ fontWeight: "bold" }}>₹{totals.toLocaleString()}</td>
//               <td colSpan="2"></td>
//             </tr>
//           </tfoot>
//         </table>
//       </div>

//       {/* Pagination */}
//       <div className="EmiDueReport-pagination">
//         <button
//           className="pagination-btn"
//           onClick={handlePrev}
//           disabled={currentPage === 1}
//         >
//           ⬅ Prev
//         </button>
//         <span className="pagination-info">
//           Page {currentPage} / {totalPages || 1}
//         </span>
//         <button
//           className="pagination-btn"
//           onClick={handleNext}
//           disabled={currentPage === totalPages || totalPages === 0}
//         >
//           Next ➡
//         </button>
//       </div>
//     </div>
//   );
// };

// // export default DepositInstallmentDueReport;
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import "../../assets/Loan/EmiDueReport.css";

// const DepositInstallmentDueReport = () => {
//   const superAdminId = Number(localStorage.getItem("userId")) || 14;

//   const [records, setRecords] = useState([]);
//   const [company, setCompany] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [filter, setFilter] = useState("today");
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(10);

//   // Correct Backend Path
//   const BASE_URL = "https://narrowitsolution.in/api/installments";

//   const API = {
//     today: `${BASE_URL}/today?branchId=${superAdminId}`,
//     tomorrow: `${BASE_URL}/tomorrow?branchId=${superAdminId}`,
//     upcoming: `${BASE_URL}/upcoming?branchId=${superAdminId}`,
//     pending: `${BASE_URL}/pending?branchId=${superAdminId}`,   // ⭐ ADDED
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       try {
//         const res = await axios.get(API[filter]);
//         setRecords(res.data.data || []);
//         setError(null);
//       } catch (err) {
//         setError("Failed to load deposit installments");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchData();
//   }, [filter]);

//   // Pagination
//   const totalPages = Math.ceil(records.length / rowsPerPage);
//   const startIndex = (currentPage - 1) * rowsPerPage;
//   const currentData = records.slice(startIndex, startIndex + rowsPerPage);

//   const totals = currentData.reduce(
//     (acc, item) => acc + (item.amount || 0),
//     0
//   );

//   const downloadPDF = () => {
//     const doc = new jsPDF("p", "mm", "a4");
//     const pageWidth = doc.internal.pageSize.width;

//     doc.text("Deposit Installment Due Report", pageWidth / 2, 14, {
//       align: "center",
//     });

//     autoTable(doc, {
//       startY: 20,
//       head: [["Sr", "Customer", "Account", "Installment No", "Amount", "Due Date", "Status"]],
//       body: currentData.map((item, i) => [
//         startIndex + i + 1,
//         item.account?.customerName,
//         item.account?.accountNo,
//         item.installmentNo,
//         item.amount,
//         new Date(item.dueDate).toLocaleDateString("en-IN"),
//         item.status,
//       ]),
//       theme: "grid",
//     });

//     doc.save("DepositInstallments.pdf");
//   };

//   return (
//     <div className="EmiDueReport-wrapper">
//       <h1 className="EmiDueReport-title">📋 Deposit Installments Due</h1>

//       {/* Filters */}
//       <div className="EmiDueReport-filters">
//         {["today", "tomorrow", "upcoming", "pending"].map((f) => (
//           <button
//             key={f}
//             className={`filter-btn ${filter === f ? "active" : ""}`}
//             onClick={() => {
//               setFilter(f);
//               setCurrentPage(1);
//             }}
//           >
//             {f.toUpperCase()}
//           </button>
//         ))}
//       </div>

//       {/* Table */}
//       <div className="EmiDueReport-table-container">
//         <table className="EmiDueReport-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Customer</th>
//               <th>Account No</th>
//               <th>Installment No</th>
//               <th>Amount</th>
//               <th>Due Date</th>
//               <th>Status</th>
//             </tr>
//           </thead>

//           <tbody>
//             {currentData.length === 0 ? (
//               <tr>
//                 <td colSpan="7" className="EmiDueReport-empty">No records found</td>
//               </tr>
//             ) : (
//               currentData.map((item, idx) => (
//                 <tr key={idx}>
//                   <td>{startIndex + idx + 1}</td>
//                   <td>{item.account?.customerName}</td>
//                   <td>{item.account?.accountNo}</td>
//                   <td>{item.installmentNo}</td>
//                   <td>₹{item.amount}</td>
//                   <td>{new Date(item.dueDate).toLocaleDateString("en-IN")}</td>
//                   <td>
//                     <span className={`EmiDueReport-status ${item.status === "Paid" ? "paid" : "pending"}`}>
//                       {item.status}
//                     </span>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>

//           <tfoot>
//             <tr className="EmiDueReport-total-row">
//               <td colSpan="4" style={{ textAlign: "right", fontWeight: "bold" }}>
//                 Total:
//               </td>
//               <td style={{ fontWeight: "bold" }}>₹{totals.toLocaleString()}</td>
//               <td colSpan="2"></td>
//             </tr>
//           </tfoot>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default DepositInstallmentDueReport;
// export default DepositInstallmentDueReport;

import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import "../../assets/Loan/EmiDueReport.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";

const DepositInstallmentDueReport = () => {
  const superAdminId = Number(localStorage.getItem("userId")) || 14;
    const dispatch = useDispatch();
    const { profile } = useSelector((state) => state.userProfile);

  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
    const [company, setCompany] = useState(null);

  const [filter, setFilter] = useState("today");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const BASE_URL = "https://narrowitsolution.in/api/installments";

  const API = {
    today: `${BASE_URL}/today?branchId=${superAdminId}`,
    tomorrow: `${BASE_URL}/tomorrow?branchId=${superAdminId}`,
    upcoming: `${BASE_URL}/upcoming?branchId=${superAdminId}`,
    pending: `${BASE_URL}/pending?branchId=${superAdminId}`,
  };

  
      useEffect(() => {
        dispatch(fetchUserProfile());
      }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(API[filter]);
        setRecords(res.data?.data || []);
        setError(null);
        setCurrentPage(1);
      } catch (err) {
        setError("Failed to load deposit installments");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [filter]);

    // ---------------- FETCH COMPANY ----------------
    useEffect(() => {
      const fetchCompany = async () => {
        try {
          const res = await fetch(
            `https://narrowitsolution.in/api/get-company?superAdminId=${profile?.superAdminId}`
          );
          const data = await res.json();
          if (res.ok && data) {
            if (data.logo)
              data.logoUrl = `https://narrowitsolution.in/${data.logo.replace(/^images\//, "")}`;
            setCompany(data);
          }
        } catch (err) {
          console.error("Failed to fetch company details", err);
        }
      };
      fetchCompany();
    }, [profile?.superAdminId]);

  const filteredData = useMemo(() => {
    if (!searchQuery.trim()) return records;

    const query = searchQuery.toLowerCase();

    return records.filter((item) =>
      [
        item.account?.customerName,
        item.account?.accountNo,
        item.installmentNo,
        item.amount,
        item.status,
        item.dueDate,
      ]
        .join(" ")
        .toLowerCase()
        .includes(query)
    );
  }, [records, searchQuery]);

  // 📄 Pagination based on filtered data
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;

  const currentData = filteredData.slice(startIndex, startIndex + rowsPerPage);

  const handlePrev = () => currentPage > 1 && setCurrentPage((p) => p - 1);
  const handleNext = () =>
    currentPage < totalPages && setCurrentPage((p) => p + 1);

  // 💰 Total of visible rows
  const totals = currentData.reduce((acc, item) => acc + (item.amount || 0), 0);

  // 📄 PDF Export
  // const downloadPDF = () => {
  //   const doc = new jsPDF();
  //   const pageWidth = doc.internal.pageSize.width;

  //   doc.text("Deposit Installment Due Report", pageWidth / 2, 14, {
  //     align: "center",
  //   });

  //   autoTable(doc, {
  //     startY: 20,
  //     head: [
  //       [
  //         "Sr",
  //         "Customer",
  //         "Account",
  //         "Installment No",
  //         "Amount",
  //         "Due Date",
  //         "Status",
  //       ],
  //     ],
  //     body: currentData.map((item, i) => [
  //       startIndex + i + 1,
  //       item.account?.customerName || "-",
  //       item.account?.accountNo || "-",
  //       item.installmentNo,
  //       item.amount,
  //       new Date(item.dueDate).toLocaleDateString("en-IN"),
  //       item.status,
  //     ]),
  //     theme: "grid",
  //   });

  //   doc.save("DepositInstallments.pdf");
  // };

    const downloadPDF = async () => {
      const doc = new jsPDF("p", "mm", "a4");
      const pageWidth = doc.internal.pageSize.width;
      const pageHeight = doc.internal.pageSize.height;
    
      // ================= LOGO =================
    // ================= LOGO WITH BORDER =================
    const logoX = 15;
    const logoY = 12;
    const logoSize = 25;
    const logoPadding = 2;
    
    // Border color & thickness
    doc.setDrawColor(0);
    doc.setLineWidth(0.2);
    
    // Calculate center of logo
    const centerX = logoX + logoSize / 2;
    const centerY = logoY + logoSize / 2;
    
    // Radius = half of logo + padding
    const radius = logoSize / 2 + logoPadding;
    
    // Draw circle
    doc.circle(centerX, centerY, radius);
    
    
    // Logo image
    if (company?.logoUrl) {
      try {
        const logoResp = await fetch(company.logoUrl);
        const logoBlob = await logoResp.blob();
        const reader = new FileReader();
        await new Promise((resolve) => {
          reader.onload = () => {
            doc.addImage(reader.result, "PNG", logoX, logoY, logoSize, logoSize);
            resolve();
          };
          reader.readAsDataURL(logoBlob);
        });
      } catch {
        // silent fail
      }
    }
    
    
      // ================= COMPANY NAME (AUTO WRAP) =================
      doc.setFont("helvetica", "bold");
      doc.setFontSize(14);
    
      const nameX = logoX + logoSize + 5;
      const nameY = 18;
      const nameMaxWidth = pageWidth - nameX - 15;
    
      const companyNameText = doc.splitTextToSize(
        (company?.name || "COMPANY NAME").toUpperCase(),
        nameMaxWidth
      );
    
      doc.text(companyNameText, nameX, nameY);
    
      // Calculate Y after company name
      let currentY = nameY + companyNameText.length * 6;
    
      // ================= COMPANY DETAILS =================
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
    
      const detailX = nameX;
      const detailMaxWidth = nameMaxWidth;
    
      // Address
      const addressText = doc.splitTextToSize(
        company?.address || "Company Address",
        detailMaxWidth
      );
      doc.text(addressText, detailX, currentY);
      currentY += addressText.length * 5;
    
      // Email
      const emailText = doc.splitTextToSize(
        `Email: ${company?.email || "-"}`,
        detailMaxWidth
      );
      doc.text(emailText, detailX, currentY);
      currentY += emailText.length * 5;
    
      // Phone
      const phoneText = doc.splitTextToSize(
        `Phone: ${company?.contact || "-"}`,
        detailMaxWidth
      );
      doc.text(phoneText, detailX, currentY);
      currentY += phoneText.length * 5;
    
      // Divider
      doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);
    
      // ================= REPORT TITLE =================
      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.text(
        "Deposit Installment Due Report",
        pageWidth / 2,
        currentY + 14,
        { align: "center" }
      );
    
      // ================= TABLE =================
      const tableColumn = [
      "Sr",
          "Customer",
          "Account",
          "Installment No",
          "Amount",
          "Due Date",
          "Status",
      ];
    
      const tableRows = currentData.map((item, i) => [
        startIndex + i + 1,
        item.account?.customerName || "-",
        item.account?.accountNo || "-",
        item.installmentNo,
        item.amount,
        new Date(item.dueDate).toLocaleDateString("en-IN"),
        item.status,
      ]);
    
      const totalRow = [
        { content: "Total", colSpan: 4, styles: { halign: "right", fontStyle: "bold" } },
        { content: totals.toLocaleString("en-IN"), styles: { fontStyle: "bold" } },
        "", "", ""
      ];
    
     autoTable(doc, {
  startY: currentY + 20,
  head: [tableColumn],
  body: tableRows,
  foot: [totalRow],

  showFoot: "lastPage", // 🔥 IMPORTANT LINE

  theme: "grid",
  styles: {
    fontSize: 7,
    cellPadding: 3,
    halign: "center",
  },
  headStyles: {
    fontStyle: "bold",
    fontSize: 7,
  },
  footStyles: {
    fillColor: [220, 220, 220],
    textColor: 20,
    fontStyle: "bold",
    fontSize: 8,
  },
  alternateRowStyles: {
    fillColor: [245, 245, 245],
  },

  didDrawPage: function () {
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    doc.setDrawColor(0);
    doc.setLineWidth(0.2);

    // Page border on EVERY page
    doc.rect(8, 8, pageWidth - 16, pageHeight - 16);
  },
});

    
      // ================= FOOTER =================
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(100);
        doc.text(
          `Page ${i} of ${pageCount}`,
          pageWidth - 30,
          pageHeight - 10
        );
        doc.text(
          "Generated by Collection System",
          14,
          pageHeight - 10
        );
      }
    
      doc.save("DepositInstallments.pdf");
    };

  return (
    <div className="EmiDueReport-wrapper">
      <h1 className="EmiDueReport-title">📋 Deposit Installments Due</h1>

      {/* Filters */}
      <div className="EmiDueReport-filters">
        {["today", "tomorrow", "upcoming", "pending"].map((f) => (
          <button
            key={f}
            className={`filter-btn ${filter === f ? "active" : ""}`}
            onClick={() => setFilter(f)}
          >
            {f.toUpperCase()}
          </button>
        ))}
      </div>

      {/* Controls */}
      <div className="EmiDueReport-controls">
        <label>
          Show{" "}
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={50000}>All</option>
          </select>{" "}
          rows
        </label>

        <input
          type="search"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />

        <button className="filter-btn" onClick={downloadPDF}>
          📄 PDF
        </button>
      </div>

      {/* Table */}
      <div className="EmiDueReport-table-container">
        <table className="EmiDueReport-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Customer</th>
              <th>Account No</th>
              <th>Installment No</th>
              <th>Amount</th>
              <th>Due Date</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7">Loading...</td>
              </tr>
            ) : currentData.length === 0 ? (
              <tr>
                <td colSpan="7" className="EmiDueReport-empty">
                  No records found
                </td>
              </tr>
            ) : (
              currentData.map((item, idx) => (
                <tr key={idx}>
                  <td>{startIndex + idx + 1}</td>
                  <td>{item.account?.customerName}</td>
                  <td>{item.account?.accountNo}</td>
                  <td>{item.installmentNo}</td>
                  <td>₹{item.amount}</td>
                  <td>{new Date(item.dueDate).toLocaleDateString("en-IN")}</td>
                  <td>
                    <span
                      className={`EmiDueReport-status ${
                        item.status === "Paid" ? "paid" : "pending"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>

          <tfoot>
            <tr className="EmiDueReport-total-row">
              <td
                colSpan="4"
                style={{ textAlign: "right", fontWeight: "bold" }}
              >
                Total:
              </td>
              <td style={{ fontWeight: "bold" }}>₹{totals.toLocaleString()}</td>
              <td colSpan="2"></td>
            </tr>
          </tfoot>
        </table>
      </div>

      {/* Pagination */}
      <div className="EmiDueReport-pagination">
        <button
          className="pagination-btn"
          disabled={currentPage === 1}
          onClick={handlePrev}
        >
          ⬅ Prev
        </button>

        <span className="pagination-info">
          Page {currentPage} / {totalPages || 1}
        </span>

        <button
          className="pagination-btn"
          disabled={currentPage === totalPages || totalPages === 0}
          onClick={handleNext}
        >
          Next ➡
        </button>
      </div>
    </div>
  );
};

export default DepositInstallmentDueReport;
